export enum ViewerDisplayMode {
    None,
    Pdf,
    Email,
    Image,
    Tchat,
    Comment,
    Text,
}
